import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useChat } from '../features/chat/hooks/useChat';
import { ChatList } from '../features/chat/components/ChatList';
import { ChatWindow } from '../features/chat/components/ChatWindow';

const ChatPage: React.FC = () => {
  const { username } = useParams<{ username?: string }>();
  const { user } = useAuth();

  const {
    conversations,
    selectedConversation,
    messages,
    loading: chatLoading,
    loadingMessages,
    selectConversation,
    sendMessage,
    loadConversations,
    onlineStatus,
    currentTime
  } = useChat(username);

  const [searchQuery, setSearchQuery] = useState('');

  if (!user) return null;

  return (
    <div className="flex h-[calc(100vh-64px)] bg-white overflow-hidden">
      {/* Sidebar */}
      <div className={`w-full md:w-80 lg:w-96 flex-shrink-0 ${selectedConversation ? 'hidden md:flex' : 'flex'}`}>
        <ChatList
          conversations={conversations}
          selectedId={selectedConversation?.id}
          onSelect={selectConversation}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          currentTime={currentTime}
        />
      </div>

      {/* Main Chat Window */}
      <div className={`flex-1 flex flex-col min-w-0 ${!selectedConversation ? 'hidden md:flex' : 'flex'}`}>
        <ChatWindow
          conversation={selectedConversation}
          messages={messages}
          currentUser={user}
          onSendMessage={sendMessage}
          loadingMessages={loadingMessages}
        />
      </div>
    </div>
  );
};

export default ChatPage;
